import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Store} from '@ngxs/store';
import {firstValueFrom, Observable} from 'rxjs';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {ClinicActions} from '../../models/clinic';
import {ExpertAction, ExpertState} from '../../models/expert';
import {Loader} from '../../models/loader/loader.redux';
import {ExpertListDTO} from '../../dtos/expert';
import {IPaginatorConfiguration} from '../paginator/paginator.component';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';

@Component({
  selector: 'app-modal-add-expert-appointment',
  templateUrl: './modal-add-expert-appointment.component.html',
  styleUrls: ['./modal-add-expert-appointment.component.scss'],
  animations: [fadeInAnimation]
})
export class ModalAddExpertAppointmentComponent implements OnInit {
  // tslint:disable:no-redundant-jsdoc
  @Input() isVisibleModal: boolean;
  @Input() clinicId: string;
  @Input() clinicBranchId: string;
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();
   experts$: Observable<ExpertListDTO[]> = this.store.select<ExpertListDTO[]>(ExpertState.getExperts);
   total$: Observable<number> = this.store.select<number>(ExpertState.getExpertsCount);

  selectedExpert: ExpertListDTO;

  disableAddExpert: boolean;

  search: string;
  actualInterval: any;
  paginatorConfig: IPaginatorConfiguration = {
    nzPageSize: 10
  };
  indexPage: number;
  constructor(
    private store: Store,
    private utilitiesServices: UtilitiesService
  ) { }

  /**
   * Inicializa las propiedades necesarias
   */
  ngOnInit(): void {
    this.search = '';
    this.selectedExpert = null;
    this.disableAddExpert = true;
    this.indexPage = 1;
  }

  /**
   * Selecciona un experto.
   * @param expert
   */
  onSelectExpert(expert: ExpertListDTO): void {
    this.selectedExpert = this.selectedExpert !== expert ? expert : null;
    this.disableAddExpert = !this.selectedExpert;
  }

  /**
   * Se cierra el modal.
   * @param emit
   */
  onEmitCloseModal(emit: boolean): void {
    if (!emit) this.selectedExpert = null;
    this.search = '';
    this.disableAddExpert = true;
    this.closeModal.emit(emit);
  }

  /**
   * Se realiza una busqueda de un experto.
   * @param $event
   */
  async onSearch($event): Promise<void> {
    if (this.actualInterval !== null) {
      clearInterval(this.actualInterval);
    }
    this.actualInterval = setTimeout(async () => {
      if (this.search === $event.target.value) return;
      this.search = $event.target.value;
      await firstValueFrom((this.store.dispatch(new Loader(true))));
      if (this.clinicBranchId) {
        // si se eligio una sucursal solo devolver a los expertos de esa surcursal y clinica
        await firstValueFrom(this.store.dispatch(new ClinicActions.GetExpertsByBranch
          (this.clinicId, this.clinicBranchId ? this.clinicBranchId : null, this.search)));
      }

      await firstValueFrom((this.store.dispatch(new Loader(false))));
    }, 400);
  }

  /**
   * Cambia el índice de la paginación.
   * @param index
   */
  async onChangePagination(index: number): Promise<void> {
    if (this.indexPage !== index) {
      await firstValueFrom((this.store.dispatch(new Loader(true))));
      this.indexPage = index;
      await this.getData();
      await firstValueFrom((this.store.dispatch(new Loader(false))));
    }
  }

  /**
   * Obtiene los datos desde el servidor.
   * @param withCount
   */
  async getData(withCount: boolean = false): Promise<void> {
    if (withCount) {
      await this.getCountExperts();
    }
    const filter = this.utilitiesServices.filterCountPagination(this.indexPage, this.paginatorConfig?.nzPageSize);
    await firstValueFrom((this.store.dispatch(new ClinicActions.GetExperts(this.clinicId, this.search, filter, true))));
  }

  /**
   * Obtiene el número total de elementos para la tabla.
   */
  async getCountExperts(): Promise<void> {
    await firstValueFrom((this.store.dispatch(new ExpertAction.GetCountByBranch(this.clinicId, this.search))));
  }
}
